<script lang="ts">
  import { TCType } from '$lib/types/RoastLog';

  interface Props {
    tcType?: TCType;
    enabled?: boolean;
  }

  let { tcType = $bindable(TCType.J), enabled = $bindable(true) }: Props = $props();

  const toggleTC = () => {
    if (tcType === TCType.J) {
      tcType = TCType.K;
    } else {
      tcType = TCType.J;
    }
  };
</script>

<button
  type="button"
  class="flex h-6 w-6 items-center justify-center rounded-full duration-300 ease-in-out dark:ring-0 dark:ring-offset-1"
  class:bg-black={tcType === TCType.J}
  class:text-white={tcType === TCType.J}
  class:ring-white={tcType === TCType.J}
  class:bg-yellow-300={tcType === TCType.K}
  class:text-black={tcType === TCType.K}
  class:ring-black={tcType === TCType.K}
  class:cursor-not-allowed={!enabled}
  disabled={!enabled}
  onclick={toggleTC}
>
  {tcType}
</button>
